import React from "react";

const MainPropLoader = () => {
    return (
        <div className="open_frame_body">
            <div className="main_prop_loader_cont">
                <div className="main_prop_loader_header fade-in">

                </div>
                <div className="main_prop_loader_body">
                    <div className="main_prop_loader_body_row">
                        <div className="main_prop_loader_body_row_cell fade-in"></div>
                        <div className="main_prop_loader_body_row_cell fade-in"></div>
                    </div>
                     <div className="main_prop_loader_body_row">
                        <div className="main_prop_loader_body_row_cell fade-in"></div>
                        <div className="main_prop_loader_body_row_cell fade-in"></div>
                    </div>
                </div>
                <div className="main_prop_loader_footer fade-in">

                </div>
            </div>
        </div>
    )
}

export default MainPropLoader